import { local_url } from '../Const';

// Cache the server's business date briefly so we don't hit the healthcheck
// API on every keystroke/row, while still staying in sync with the server
// (which is the source of truth for "today" — the client's clock/timezone
// can be wrong and was causing false "cannot be less than today" errors).
let cachedTodayStr = null;
let cachedAtMs = 0;
const CACHE_TTL_MS = 60 * 1000;

const toDateStr = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Fetches "today" (YYYY-MM-DD) from the server's healthcheck API, refreshing
// the cache if it's stale. Falls back to the local clock if the API call fails.
export async function getServerTodayStr() {
    if (cachedTodayStr && (Date.now() - cachedAtMs) < CACHE_TTL_MS) {
        return cachedTodayStr;
    }
    try {
        const response = await fetch(`${local_url}/api/healthcheck`);
        if (!response.ok) throw new Error(`Healthcheck request failed with status ${response.status}`);
        const data = await response.json();
        cachedTodayStr = toDateStr(new Date(data.businessDate));
        cachedAtMs = Date.now();
    } catch (err) {
        console.error('Failed to fetch server date from healthcheck API, falling back to local date:', err);
        cachedTodayStr = toDateStr(new Date());
        cachedAtMs = Date.now();
    }
    return cachedTodayStr;
}

// Synchronous read of the last known server date, for use inside code paths
// (e.g. tight validation loops) that can't await. Callers should call
// getServerTodayStr() once beforehand to warm/refresh this cache.
export function getCachedServerTodayStr() {
    return cachedTodayStr || toDateStr(new Date());
}
